function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

// Cache if we've seen an image before so we don't both with
// lazy-loading & fading in on subsequent mounts.
var imageCache = {};
var inImageCache = function inImageCache(props) {
  // Find src
  var src = props.sizes ? props.sizes.src : props.resolutions.src;

  if (imageCache[src]) {
    return true;
  } else {
    imageCache[src] = true;
    return false;
  }
};

var io = void 0;
var listeners = [];

function getIO() {
  if (typeof io === 'undefined' && typeof window !== 'undefined' && window.IntersectionObserver) {
    io = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        listeners.forEach(function (l) {
          if (l[0] === entry.target) {
            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              io.unobserve(l[0]);
              l[1]();
            }
          }
        });
      });
    }, { rootMargin: '200px' });
  }

  return io;
}

var listenToIntersections = function listenToIntersections(el, cb) {
  getIO().observe(el);
  listeners.push([el, cb]);
};

var isWebpSupportedCache = null;
var isWebpSupported = function isWebpSupported() {
  if (isWebpSupportedCache !== null) {
    return isWebpSupportedCache;
  }

  var elem = typeof window !== 'undefined' ? window.document.createElement('canvas') : {};
  if (elem.getContext && elem.getContext('2d')) {
    isWebpSupportedCache = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  } else {
    isWebpSupportedCache = false;
  }

  return isWebpSupportedCache;
};

var ImageLoader = function (_Component) {
  _inherits(ImageLoader, _Component);

  function ImageLoader(props) {
    _classCallCheck(this, ImageLoader);

    // If this browser doesn't support the IntersectionObserver API
    // we default to start downloading the image right away.
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._onImageLoad = function () {
      _this.setState({
        imgLoaded: true,
        src: _this.img.currentSrc
      });
      _this.props.onLoad && _this.props.onLoad();
    };

    var isVisible = true;
    var imgLoaded = true;
    var IOSupported = false;
    var src = null;

    // If this image has already been loaded before then we can assume it's
    // already in the browser cache so it's cheap to just show directly.
    var seenBefore = inImageCache(props);

    if (!seenBefore && typeof window !== 'undefined' && window.IntersectionObserver) {
      isVisible = false;
      imgLoaded = false;
      IOSupported = true;
    }

    // Always don't render image while server rendering
    if (typeof window === 'undefined') {
      isVisible = false;
      imgLoaded = false;
    }

    if (seenBefore) {
      src = props.sizes ? props.sizes.src : props.resolutions.src;
    } else {
      src = props.sizes ? props.sizes.base64 || props.sizes.tracedSVG : props.resolutions.src || props.sizes.tracedSVG;
    }

    _this.state = {
      isVisible: isVisible,
      imgLoaded: imgLoaded,
      IOSupported: IOSupported,
      src: src
    };

    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }

  ImageLoader.prototype.handleRef = function handleRef(ref) {
    var _this2 = this;

    if (this.state.IOSupported && ref) {
      listenToIntersections(ref, function () {
        _this2.setState({ isVisible: true, imgLoaded: false });
      });
    }
  };

  ImageLoader.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        alt = _props.alt,
        sizes = _props.sizes,
        resolutions = _props.resolutions,
        children = _props.children;


    if (sizes) {
      var image = sizes;

      // Use webp by default if browser supports it
      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
        image.src = image.srcWebp;
        image.srcSet = image.srcSetWebp;
      }

      var renderProps = {
        src: this.state.src,
        imgLoaded: this.state.imgLoaded
      };

      return React.createElement(
        Fragment,
        null,
        React.createElement(
          'div',
          { ref: this.handleRef },
          this.state.isVisible && React.createElement('img', {
            alt: alt,
            title: title,
            src: image.src,
            srcSet: image.srcSet,
            sizes: image.sizes,
            ref: function ref(x) {
              return _this3.img = x;
            },
            style: { display: 'none' },
            onLoad: this._onImageLoad
          })
        ),
        children(renderProps)
      );
    }

    if (resolutions) {
      var _image = resolutions;

      // Use webp by default if browser supports it
      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
        _image.src = _image.srcWebp;
        _image.srcSet = _image.srcSetWebp;
      }

      var _renderProps = {
        src: this.state.src,
        imgLoaded: this.state.imgLoaded
      };

      return React.createElement(
        Fragment,
        null,
        React.createElement(
          'div',
          { ref: this.handleRef },
          this.state.isVisible && React.createElement('img', {
            alt: alt,
            title: title,
            src: _image.src,
            srcSet: _image.srcSet,
            ref: function ref(x) {
              return _this3.img = x;
            },
            style: { display: 'none' },
            onLoad: this._onImageLoad
          })
        ),
        children(_renderProps)
      );
    }

    return null;
  };

  return ImageLoader;
}(Component);

ImageLoader.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.func.isRequired,
  sizes: PropTypes.object,
  resolutions: PropTypes.object,
  title: PropTypes.string,
  alt: PropTypes.string,
  onLoad: PropTypes.func
} : {};

export default ImageLoader;